import { envCustomizations } from "./config";
import { appEnvironment } from "./constants";

export const initializeApiClient = (
  client,
  { useEnvName = appEnvironment } = {}
) => {
  // Register known env configurations.
  Object.keys(envCustomizations).forEach((envName) => {
    client.registerEnvironmentConfig(envName, envCustomizations[envName]);
  });

  // Ensure the client is driven by the current environment's configuration.
  client.useEnvironment(useEnvName);

  return client;
};

const init = { initializeApiClient };

export default init;
